import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { TAiReviewDto } from '@app-velocity/av-api-v2';

import { Button } from '@app-velocity/ui';

import { useSimulationWidgetContext } from '../../../../../../hooks/useSimulationWidgetContext';

export type ActionButtonProps = {
  children: ReactNode;
  disabled?: boolean;
  onClick: () => void;
};

const StyledButton = styled(Button)({
  flex: '1 0 40%',
});

const getColor = (
  status: TAiReviewDto['reviewStatus'] | null,
  simSuccesses: number,
  simFailures: number
) => {
  if (!status || status === 'IN_PROGRESS') return 'info';

  const successToFailureRatio = simSuccesses / (simSuccesses + simFailures);

  if (successToFailureRatio >= 0.7) return 'success';

  return 'error';
};

export const ActionButton = ({
  children,
  disabled,
  onClick,
}: ActionButtonProps) => {
  const { parsedStatus, statistics } = useSimulationWidgetContext();

  return (
    <StyledButton
      disabled={disabled}
      onClick={onClick}
      variant="action"
      size="small"
      color={getColor(
        parsedStatus,
        statistics?.simulatedReviews.succeded || 0,
        statistics?.simulatedReviews.failed || 0
      )}
    >
      {children}
    </StyledButton>
  );
};
